import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { FaAngleRight } from "react-icons/fa";

const Category = ({ product, setProduct, categoriesObj }) => {
  const categoryRef = useRef();

  const [viewCategories, setViewCategories] = useState(false);
  const [category, setCategory] = useState([]);
  const [search, setSearch] = useState(
    categoriesObj[product.categoryId] ? categoriesObj[product.categoryId] : "",
  );
  const [searched, setSearched] = useState(false);

  useEffect(() => {
    if (!search) {
      setCategory([]);
      return;
    }
    getCategory(search);
  }, [search]);

  // 검색어 입력 시 카테고리 조회
  const getCategory = async (keyword) => {
    try {
      const res = await axios.post("/api/categories/search", { keyword });
      if (res.status === 200) {
        setCategory(
          sortCategories(res?.data || []).map((item) => ({
            categoryId: item.categoryId,
            categoryName: item.fullPath,
          })),
        );

        if (!searched) {
          setSearched(true);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 카테고리 선택 시 제품 상태 변경
  const handleSelectCategory = (cate) => {
    setViewCategories(false);
    setProduct((data) => ({ ...data, categoryId: cate.categoryId }));
    setSearch(categoriesObj[cate.categoryId] ? categoriesObj[cate.categoryId] : "");
  };

  useEffect(() => {
    if (!viewCategories) return;

    // 외부 클릭 감지
    const handleClickOutside = (event) => {
      if (categoryRef.current && !categoryRef.current.contains(event.target)) {
        setViewCategories(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [viewCategories]);

  return (
    <li className="category">
      <span className="tit">카테고리</span>
      <div className="cont" ref={categoryRef}>
        {viewCategories ? (
          <>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="카테고리를 검색해주세요."
            />
            {searched && (
              <ul className="categories">
                {category.length > 0 ? (
                  category.map((cate) => (
                    <li
                      key={cate.categoryId}
                      onClick={() => handleSelectCategory(cate)}
                      className={cate.categoryId === product.categoryId ? "active" : "inactive"}>
                      {cate.categoryName}
                    </li>
                  ))
                ) : (
                  <li>검색 결과가 없습니다.</li>
                )}
              </ul>
            )}
          </>
        ) : (
          <div className="selection" onClick={() => setViewCategories(true)}>
            {categoriesObj[product.categoryId] ? (
              <span>{categoriesObj[product.categoryId]}</span>
            ) : (
              <span className="placeholder">카테고리를 검색해주세요.</span>
            )}
            <button>
              <FaAngleRight />
            </button>
          </div>
        )}
      </div>
    </li>
  );
};

export default Category;
